import React, { useEffect, useState } from 'react'
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '../config/firebase'
import { DEFAULT_BRANDING } from '../config/appConfig'
import type { AppBranding } from '../config/appConfig'

// Context
export const BrandingContext = React.createContext<AppBranding>(DEFAULT_BRANDING)

/**
 * Provider yang memantau perubahan branding dari Firestore secara real-time.
 * appConfig/branding dapat dibaca publik sehingga tersedia di halaman login & murid.
 */
export function BrandingProvider({ children }: { children: React.ReactNode }) {
  const [branding, setBranding] = useState<AppBranding>(DEFAULT_BRANDING)

  useEffect(() => {
    const ref = doc(db, 'appConfig', 'branding')
    const unsubscribe = onSnapshot(
      ref,
      (snap) => {
        if (snap.exists()) {
          const data = snap.data()
          setBranding({
            appName: data.appName ?? DEFAULT_BRANDING.appName,
            appFullName: data.appFullName ?? DEFAULT_BRANDING.appFullName,
            logoUrl: data.logoUrl ?? null,
            logoVersion: data.logoVersion ?? 0,
            updatedAt: data.updatedAt?.toDate(),
          })
        }
      },
      (error) => {
        // Jika gagal (misal belum ada koneksi), pakai default
        console.warn('[BrandingProvider] Gagal memuat branding:', error.message)
      }
    )
    return () => unsubscribe()
  }, [])

  return (
    <BrandingContext.Provider value={branding}>
      {children}
    </BrandingContext.Provider>
  )
}

/** Hook untuk menggunakan branding di komponen manapun */
export function useBranding() {
  return React.useContext(BrandingContext)
}
